function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsxs as h, jsx as e } from "react/jsx-runtime";
import d from "./box.js";
import { Text as f } from "./text.js";
import { useThemeVariant as v, ThemeVariant as w } from "./theme-variant-context.js";
import { pxToRem as T } from "./utils/css.js";
import { getPrefixedDataAttributes as x } from "./utils/dom.js";
import { tag as H } from "./tag.css-mistica.js";
import { sprinkles as m } from "./sprinkles.css-mistica.js";
import { vars as L } from "./skins/skin-contract.css-mistica.js";
import b from "classnames";
import { useTheme as I } from "./hooks.js";
const { colors: r  } = L, k = (param)=>{
    let { Icon: o , children: s , dataAttributes: c , type: g = "promo"  } = param;
    const { textPresets: l  } = I(), i = v(), t = i === "inverse";
    if (!s) return null;
    const p = {
        // [textColor, inverseTextColor, backgroundColor]
        promo: [
            r.promoHigh,
            r.promoHighInverse,
            r.promoLow
        ],
        active: [
            r.brand,
            r.brand,
            r.brandLow
        ],
        inactive: [
            r.neutralMedium,
            r.neutralMediumInverse,
            i === "alternative" ? r.neutralLowAlternative : r.neutralLow
        ],
        success: [
            r.successHigh,
            r.successHighInverse,
            r.successLow
        ],
        warning: [
            r.warningHigh,
            r.warningHighInverse,
            r.warningLow
        ],
        error: [
            r.errorHigh,
            r.errorHighInverse,
            r.errorLow
        ]
    }, [n, a, u] = p[g];
    return /* @__PURE__ */ h("span", _object_spread_props(_object_spread({}, x(c, "Tag")), {
        className: b(H, m({
            paddingLeft: o ? 8 : 12,
            background: t ? r.inverse : u
        })),
        children: [
            o && /* @__PURE__ */ e(d, {
                paddingRight: 4,
                children: /* @__PURE__ */ e(o, {
                    color: t ? a : n,
                    size: T(16),
                    className: m({
                        display: "block"
                    })
                })
            }),
            /* @__PURE__ */ e(w, {
                isInverse: !1,
                children: /* @__PURE__ */ e(f, {
                    color: t ? a : n,
                    size: 14,
                    lineHeight: 20,
                    weight: l.indicator.weight,
                    truncate: !0,
                    children: s
                })
            })
        ]
    }));
}, D = k;
export { D as default };
